import { UserPaymentTableEntry } from "../apis/armoryApi";
import { useArmoryApi } from "../hooks/useArmoryApi";
import { ColumnMeta } from "./tables/BaseDataTable";
import UserPaymentDataTable from "./tables/UserPaymentDataTable";
import { ReactNode, useEffect, useState } from "react";

interface AssetPaymentsPanelProps {
  assetId: number;
  additionalActions?: ReactNode;
}

const AssetPaymentsPanel: React.FC<AssetPaymentsPanelProps> = ({ assetId, additionalActions }) => {
  const { getUserPaymentsByInventoryObject, getUserPaymentById } =
    useArmoryApi();

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [payments, setPayments] = useState<UserPaymentTableEntry[]>([]);

  const getAssetPayments = async () => {
    if (assetId) {
      console.log("Fetching payments for assetId:", assetId);
      const apiResponse = await getUserPaymentsByInventoryObject(assetId);

      if (apiResponse.data) {
        setPayments(apiResponse.data);
        setTimeout(() => {
          setIsLoading(false);
        }, 0);
      } else {
        console.log(apiResponse.error)
      }
    } else {
      console.log("No assetId provided.");
    }
  };
  useEffect(() => {
    getAssetPayments();
  }, [assetId]);

  return (
    <UserPaymentDataTable
      isLoading={isLoading}
      userPaymentsData={payments}
      onRefreshButtonClick={getAssetPayments}
      columnOverrides={
        [
          {
            field: "id",
            isVisible: false
          },
          {
            field: "inventoryObjectDesc",
            isVisible: false
          },
          {
            field: "isDeleted",
            isVisible: false
          }
        ] as ColumnMeta<UserPaymentTableEntry>[]
      }
      additionalActions={additionalActions}
    />
  );
};

export default AssetPaymentsPanel;
